/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { V2PaymentPrepareRequest, V2PaymentResponse } from '@api';
import { Create, Request } from 'src/js/common/epics/EpicUtils';
import { CHECKOUT_PROCESS_SQUARE_CC_PAYMENT } from 'src/js/enrol/containers/payment/actions/Actions';
import CheckoutApiService from 'src/js/enrol/services/CheckoutApiService';
import CheckoutService, { BuildCheckoutModelRequest } from 'src/js/enrol/services/CheckoutService';

const request: Request<V2PaymentResponse, { creditCardToken: string, verificationToken: string }> = {
  type: CHECKOUT_PROCESS_SQUARE_CC_PAYMENT,
  getData: async ({ creditCardToken, verificationToken }, state) => {

    const paymentRequest: V2PaymentPrepareRequest = {
      checkoutModelRequest: await BuildCheckoutModelRequest.fromState(state),
      storeCard: false,
      ccAmount: state.checkout.amount.ccPayment,
    };

    const sessionResponse = await CheckoutApiService.createSession(
      paymentRequest,
      state.checkout.payerId,
      state.checkout.payment.sessionId
    )

    return CheckoutApiService.submitCreditCardPayment(
      {
        merchantReference: sessionResponse.merchantReference,
        cardDataToken: creditCardToken,
        secureCode: verificationToken,
        onCourseSessionId: sessionResponse.sessionId
      },
      state.checkout.payerId
    )
  },
  processData: (response: V2PaymentResponse) => CheckoutService.processPaymentResponse(response),
  processError: CheckoutService.prcessPaymentError
};

export const EpicSquarePayment = Create(request);